/**
 * Shared candle utility functions.
 * Single source of truth for timestamp resolution — used by both
 * marketsSlice (Redux) and candleMerging (cache layer).
 */

/**
 * Resolve a numeric timestamp from a candle object.
 * Checks `candle.t` first, then falls back to common date-string fields.
 *
 * @param {object} candle
 * @returns {number|null} epoch ms or null
 */
export function resolveTimestampFromCandle(candle) {
  if (!candle || typeof candle !== 'object') {
    return null;
  }

  if (Number.isFinite(candle.t)) {
    return candle.t;
  }

  const source =
    candle.date ||
    candle.datetime ||
    candle.timestamp ||
    candle.time ||
    candle.startDate ||
    candle.endDate;

  if (!source) {
    return null;
  }

  const timestamp = new Date(source).getTime();
  return Number.isFinite(timestamp) ? timestamp : null;
}
